import { render } from "./WaitDialog.vue?vue&type=template&id=52a9da66&scoped=true"
import script from "./WaitDialog.vue?vue&type=script&lang=js"
export * from "./WaitDialog.vue?vue&type=script&lang=js"

import "./WaitDialog.vue?vue&type=style&index=0&id=52a9da66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a9da66"],['__file',"src/components/WaitDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52a9da66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52a9da66', __exports__)) {
    api.reload('52a9da66', __exports__)
  }
  
  module.hot.accept("./WaitDialog.vue?vue&type=template&id=52a9da66&scoped=true", () => {
    api.rerender('52a9da66', render)
  })

}


export default __exports__